import React from 'react';

import { default as LinearProgress } from '@material-ui/core/LinearProgress';

import Translator from '../../../../../../../../helpers/TranslationHelper';
import SourceSetReport from '../../../../../Report';
import { useStyles } from './Themable.hooks';

import { ILastState } from '../../../../../../../../state/types';
import PreviewDialog from '../../../Dialog';
import AlertSettingDialog from '../../../../../../../../components/AlertSettingDialog';
import {
    useDiscoveryUIDialog,
    useGridFilters,
    usePane,
} from '../../../../../../../../pages/discovery/selectors/index.hooks';
import {
    fetchLastState,
    fetchLastStates,
} from '../../../../../../../../state/_actions';

import { useIsReportSetBeingFetched } from '../../../../../../../../state/app/fetching/selectors/index.hooks';

import { useAppDispatch } from '../.../../../../../../../../../hooks';

interface IOwnProps {
    lastState: ILastState;
    afterItemDelete?: () => void;
}

const LastStateReports = ({ lastState }: IOwnProps) => {
    const dispatch = useAppDispatch();

    const classes = useStyles();
    const isReportSetBeingFetched = useIsReportSetBeingFetched();
    const dialog = useDiscoveryUIDialog();
    const preview = usePane();
    const filters = useGridFilters();

    const afterItemDelete = () => {
        dispatch(fetchLastStates(preview?.elementId, filters));
    };

    return (
        <React.Fragment>
            {isReportSetBeingFetched && <LinearProgress />}

            {lastState ? (
                lastState.reports.map((report, index) => (
                    <SourceSetReport
                        key={index}
                        report={report}
                        preview={null}
                        afterItemDelete={afterItemDelete}
                    />
                ))
            ) : (
                <p className={classes.emptyState}>
                    {Translator.translate('No data to display')}
                </p>
            )}
            <PreviewDialog>
                <AlertSettingDialog
                    dialog={dialog}
                    onSubmit={(filters) =>
                        dispatch(fetchLastState(dialog?.elementId, filters))
                    }
                />
            </PreviewDialog>
        </React.Fragment>
    );
};

export default LastStateReports;
